import React from 'react';
import SectionHeader from './SectionHeader';
import RYGRadio from './RYGRadio';
import NotesInput from './NotesInput';

const OPTIONS = [
  { value: 'red', label: "I'm blissfully unaware" },
  { value: 'yellow', label: "I think I've got it covered, but I worry I missed something" },
  { value: 'green', label: "I'm aware of the risks that relate to my financial situation" },
];

/**
 * Section 3 — Risk Awareness.
 */
export default function StepRiskAwareness({ data, onChange }) {
  return (
    <div>
      <SectionHeader
        number={3}
        title="Do you know the significant risks that could derail your finances?"
        showAnnualNote={false}
      />
      <div className="cashflow-section-card">
        <RYGRadio
          id="risk_awareness"
          options={OPTIONS}
          value={data?.answer}
          onChange={(val) => onChange({ ...(data || {}), answer: val })}
        />
      </div>

      <NotesInput
        value={data?.notes}
        onChange={(val) => onChange({ ...(data || {}), notes: val })}
      />
    </div>
  );
}
